import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { FirebaseAppContext } from 'libs.firebase_react';
import { useLocalizationImportV2 } from 'libs.localization.react';
import { useLocalizeMessage, Spinner } from 'libs.nucleus';
import { ButtonWithTooltip, useBooleanState } from 'libs.react';
import { ImportModalV2 } from '../study/import_modal';
export const DashboardImportActionV2 = ({ isDisabled, variant = 'secondary', label, requiredIds = [], supportedLocales = [], showTooltip = false, tooltipText = '', trackingContext = {}, onImport = () => { }, studyId, onStudyConfigSynced, }) => {
    const t = useLocalizeMessage();
    const [isImportModalOpen, openImportModal, closeImportModal] = useBooleanState(false);
    const { isPending: isImporting, importLocalization } = useLocalizationImportV2({
        onImport,
        studyId,
        onStudyConfigSynced,
    });
    const { logEvent } = useContext(FirebaseAppContext);
    const handleImport = useCallback(async ({ files }) => {
        importLocalization({ files, requiredIds, supportedLocales }, {
            onSuccess: () => {
                closeImportModal();
            },
        });
        logEvent('translations_localization_imported', {
            ...trackingContext,
            requiredIds: requiredIds.join(','),
            serviceVersion: 'v2',
        });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(ButtonWithTooltip, { enableTooltip: showTooltip, tooltip: tooltipText, variant: variant, onClick: openImportModal, label: label || t('Import'), disabled: isDisabled, content: isImporting ? (_jsx("div", { className: 'py-1', children: _jsx(Spinner, { size: 'sm', variant: variant === 'primary' ? 'alt' : 'default' }) })) : undefined }), isImportModalOpen && (_jsx(ImportModalV2, { onModalClose: closeImportModal, onHandleImport: handleImport, isLoading: isImporting }))] }));
};
